const selectAgentSystemHistory = (state) => state.history;
export const selectAgentSystemHistoryData = (state) => selectAgentSystemHistory(state).data;
export const selectAgentSystemHistoryTotal = (state) => selectAgentSystemHistory(state).total;
